import React from 'react';
import { motion } from 'framer-motion';
const phases = [{
  num: '01',
  title: 'Reset',
  subtitle: 'Limpieza',
  description: 'Eliminamos los irritantes ocultos que inflaman tu intestino. Desbloquea tu energía natural desde la primera semana.'
}, {
  num: '02',
  title: 'Reintroducción',
  subtitle: 'Detección',
  description: 'Descubre exactamente qué alimentos te inflaman a TI con un sistema guiado paso a paso.'
}, {
  num: '03',
  title: 'Sellado',
  subtitle: 'Protección',
  description: 'Fortalecemos la barrera intestinal. Recupera la paz digestiva y mantén tu vientre plano para siempre.'
}];
export function Method() {
  return <section className="py-32 md:py-44 bg-white" data-id="element-91">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-92">
        <div className="text-center mb-20" data-id="element-93">
          <h2 className="font-serif text-4xl md:text-5xl font-semibold tracking-tight text-forest" data-id="element-94">
            El Método Biome-Reset™
          </h2>
        </div>

        <div className="relative" data-id="element-95">
          {/* Desktop Connecting Line */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-[1px] bg-sage-dark z-0" data-id="element-96"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-97">
            {phases.map((phase, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="flex flex-col items-center text-center" data-id="element-98">
                <div className="w-24 h-24 bg-white border-4 border-sage rounded-full flex items-center justify-center mb-8 shadow-sm" data-id="element-99">
                  <span className="text-3xl font-bold text-forest tracking-tighter" data-id="element-100">
                    {phase.num}
                  </span>
                </div>
                <h3 className="text-2xl font-bold text-forest mb-1" data-id="element-101">
                  {phase.title}
                </h3>
                <span className="text-sm font-semibold text-forest/60 tracking-widest uppercase mb-4 block" data-id="element-102">
                  {phase.subtitle}
                </span>
                <p className="text-forest/80 leading-relaxed max-w-xs" data-id="element-103">
                  {phase.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}